<template>
  <div class="empty-profile-banner">
    <div class="f-h f-ac">
      <div class="f-v m-rx2">
        <div class="f-h">
          <cdn-svg path="nucleo/donut-1" />
          <cdn-svg path="nucleo/donut-3" />
        </div>
        <div class="f-h">
          <cdn-svg path="nucleo/donut-4" />
          <cdn-svg path="nucleo/donut-2" />
        </div>
      </div>
      <div class="f-v">
        <div class="t brown bold">
          Complete your Donut profile!
        </div>
        <div class="t brown m-tx1">
          Fill out the topics below to help your teammates get to know you better — answers will be shared in your profile and Donut Intros.
        </div>
      </div>
      <donut-button class="m-lx1" @click="emit('editProfile')">
        <div class="f-h f-ac">
          <i class="mi md-18 m-rx1">edit</i>
          <div class="t nowrap">Edit profile</div>
        </div>
      </donut-button>
    </div>
  </div>
</template>

<script setup>
const emit = defineEmits(['editProfile']);
</script>

<style scoped lang="scss">
  @import '../../styles/donut';

  .empty-profile-banner {
    background-color: $light-orange;
    border-radius: 8px;
    padding: 16px;
  }
</style>
